import Env from '@/env/env'
import HttpClient from '@/common/lib/http-client'

const token: HTMLMetaElement | null = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    HttpClient.baseUrl = Env.basePath
    HttpClient.headers.set('X-CSRF-TOKEN', token.content)
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}
